<template>
  <div :style="{backgroundImage:`url(${pageBg})`}" class="pageItem">
    <vue-draggable-resizable v-for="(item,index) in page" :draggable="false" :resizable="false"
                             :class="activeId === item.id ? 'activeId' :''" :scaleRatio="zoom"
                             :x="item.infoLeftDr" :y="item.infoTopDr" :w="item.infoWidthDr"
                             :h="item.infoHeightDr" :key="item.id" :index="index">
      <div class="node-content">
        <div class="node-content-type animated"
             v-if="item.type === 'img'" :style="{
        'animation-duration': item.animate.animationDuration  + 's', // 动画周期
        'animation-timing-function': item.animate.animationTimingFunction,  // 运行曲线
        'animation-delay': item.animate.animationDelay + 's', // 动画延时
        'animation-iteration-count': item.animate.animationIterationCount, // 播放次数
        'transform':`rotate(${item.classify.rotationAngle}deg)`
      }">
          <img :src="item.url" alt="" draggable="false">
        </div>
        <div class="node-content-type animated"
             v-else-if="item.type === 'text'"
             :style="{
        'animation-duration': item.animate.animationDuration  + 's', // 动画周期
        'animation-timing-function': item.animate.animationTimingFunction,  // 运行曲线
        'animation-delay': item.animate.animationDelay + 's', // 动画延时
        'animation-iteration-count': item.animate.animationIterationCount, // 播放次数
        'transform': `rotate(${item.classify.rotationAngle}deg)`,
        'height':'100%',
        'text-shadow':`${item.classify.fontShadowColor} 0px 0px ${item.classify.fontShadow}px`,
        'box-shadow':`${item.classify.shadowColor} 0px 0px ${item.classify.shadow}px`,
        'color':`${item.classify.fontColor}`,
        'font-size':`${item.classify.fontSize}px`,
      }">
          {{ item.content }}
        </div>

      </div>
    </vue-draggable-resizable>
  </div>
</template>

<script>
import {mapState} from "vuex"

import VueDraggableResizable from 'vue-draggable-resizable-gorkys'


export default {
  name: "node",
  props: {
    page: {
      type: Array
    },
    zoom: {
      type: Number,
      default: 1
    },
    pageBg: {
      type: String
    },
    pageItemIndex: {
      type: Number,
      default: 0
    },
    realIndex: {
      type: Number,
      default: 0
    },
    x: {
      type: Number
    },
    y: {
      type: Number
    },
    activeId: {
      type: String
    }
  },

  components: {VueDraggableResizable},
  data() {
    return {}
  },
  methods: {},
  computed: {
    ...mapState({
      isActive: state => state.isActive
    })
  },
}
</script>

<style lang="scss">

@import "~vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css";

.pageItem {
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  transform-origin: 0 0;

  .vdr{
    border: none !important;
  }
  .active {
    border: 1px solid transparent;
  }

  .activeId {
    border: 2px solid #ff0000;
  }

  .node-content {
    width: 100%;
    height: 100%;

    .node-content-type {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}


</style>
